import React, { useState, useEffect } from "react";
import Loader from "../Components/Loader";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { createSession } from "../../redux/actions/sessionAction";
import { useFormik } from "formik";
import {
  generateLinkSchema,
  SOCKET_EVENT_TYPE,
  useGenerateLinkSchema,
  USER_CURRENT_PATH,
} from "../../helpers/common";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useSocket } from "../Components/SocketContext";
import useSocketHandlers from "../Components/useSocketHandlers";
import { resetSessionState } from "../../redux/slices/sessionSlice";
import { resetFeelingState } from "../../redux/slices/feelingSlice";

const StartPage = () => {
  const isLoading = useSelector((state) => state.session.isLoading) || false;
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { socket } = useSocket();
  const { handleCreateSession, handleSocketErr } = useSocketHandlers();
  const [language, setLanguage] = useState(localStorage.getItem("i18nextLng"));

  useEffect(() => {
    const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
    if (loggedUser && loggedUser.name !== "") {
      navigate(
        `${process.env.REACT_APP_FRONT_URL}${USER_CURRENT_PATH.START_AFTER_STOP}`,
      );
    }
  }, []);

  useEffect(() => {
    try {
      let currentUser = localStorage.getItem("currentUser");
      let userName = null;
      if (currentUser) {
        currentUser = JSON.parse(currentUser);
        userName = currentUser?.name;
      }
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (
          !["setLang", "langName", "i18nextLng", "visitedPages"].includes(key)
        ) {
          localStorage.removeItem(key);
        }
      }
      if (userName) {
        localStorage.setItem("currentUser", JSON.stringify({ name: userName }));
      }
      localStorage.setItem("visitedPages", JSON.stringify([]));
      dispatch(resetSessionState());
      dispatch(resetFeelingState());
    } catch (error) {
      console.error("Error during localStorage manipulation:", error);
    }
  }, []);

  useEffect(() => {
    if (socket) {
      socket.on(SOCKET_EVENT_TYPE.CREATED_SESSION, handleCreateSession);
      socket.on(SOCKET_EVENT_TYPE.ERROR, handleSocketErr);
      return () => {
        socket.off(SOCKET_EVENT_TYPE.CREATED_SESSION, handleCreateSession);
        socket.off(SOCKET_EVENT_TYPE.ERROR, handleSocketErr);
      };
    }
  }, [socket, navigate, handleCreateSession, handleSocketErr]);

  const startPageFormik = useFormik({
    initialValues: { name: "" },
    validationSchema: useGenerateLinkSchema(),
    onSubmit: async (values) => {
      await dispatch(createSession(values));
    },
  });

  useEffect(() => {
    i18n.on("languageChanged", (lng) => {
      setLanguage(lng); // Update the language state
      startPageFormik.validateForm(); // Revalidate Formik fields when language changes
    });
  }, [i18n]);

  return (
    <>
      <div className="content-box contact">
        {!isLoading ? (
          <div className="main_content">
            <div className="page_head">
              <h2 className="page_title" data-i18n="[html]content.body">
                <Trans
                  i18nKey={"greeting_greethead"}
                  components={{ 1: <br /> }}
                />
              </h2>
              <p className="sub_head">{t("greeting_greetpara")}</p>
            </div>
            <div className="discussion_box">
              <div className="innerContainer">
                <div className="start_discussion">
                  <h4 className="medium">{t("startDiscuss")}</h4>
                </div>
              </div>
              <Form onSubmit={startPageFormik.handleSubmit}>
                <div className="discussion_bg">
                  <div className="innerContainer">
                    <div className="participant_name">
                      <div className="input_box">
                        <label>{t("formNameLabel")}</label>
                        <input
                          name="name"
                          onChange={startPageFormik.handleChange}
                          onBlur={startPageFormik.handleBlur}
                          value={startPageFormik.values.name}
                          placeholder={t("formNamePlaceholder")}
                        />
                        {startPageFormik.errors.name &&
                          startPageFormik.touched.name && (
                            <div style={{ color: "red" }}>
                              {startPageFormik.errors.name}
                            </div>
                          )}
                      </div>
                      <button
                        type="submit"
                        className="theme_btn"
                        disabled={
                          !startPageFormik.isValid ||
                          startPageFormik.isSubmitting
                        }
                      >
                        {t("formSubmitBtn")}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        ) : (
          <div className="innerContent">
            <div className="listenBtn">
              <button className="waved_btn">
                <Trans
                  i18nKey={"listenAfterContinue"}
                  // values={{ receiver: userName }}
                  components={{ 1: <br></br> }}
                />
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default StartPage;
